// gavion.email.segments.* — segment builder copy (B5-T14).
export const segmentsMessages = {
  fr: {
    title: "Segments",
    new: "Nouveau segment",
    name: "Nom du segment",
    entity: "Type",
    updated: "Modifié",
    entities: { companies: "Entreprises", contacts: "Contacts" },
    conditions: "Conditions",
    combine: "Combiner",
    all: "Toutes les conditions",
    any: "Au moins une condition",
    add_condition: "Ajouter une condition",
    add_group: "Ajouter un groupe",
    remove: "Retirer",
    remove_group: "Retirer le groupe",
    group_n: "Groupe %{n}",
    field_n: "Champ %{n}",
    op_n: "Opérateur %{n}",
    value_n: "Valeur %{n}",
    choose: "Choisir…",
    cap_reached: "Maximum de %{max} conditions atteint.",
    invalid: "Le filtre du segment est invalide.",
    err_days: "Entrez un nombre entier de jours entre 0 et 36500.",
    err_id: "Entrez un identifiant entier entre 1 et 2147483647.",
    err_list: "Maximum de 1000 éléments dans la liste.",
    entity_reset_confirm:
      "Changer le type efface les conditions actuelles. Continuer ?",
    legacy_warning:
      "Ce segment utilise un ancien format de filtre. L'enregistrer le remplacera par les conditions ci-dessous.",
    count_error: "Impossible de calculer le nombre de compagnies.",
    groups: {
      company: "Entreprise",
      prospecting: "Prospection",
      deals: "Affaires",
      email: "Courriel",
      contacts: "Contacts",
    },
    fields: {
      trade: "Métier",
      region: "Région",
      city: "Ville",
      segment: "Segment",
      fit_score: "Score de pertinence",
      high_quality: "Haute qualité",
      has_email: "A un courriel",
      created_at: "Date de création",
      date_added: "Date d'ajout",
      prospect_status: "Statut de prospection",
      last_call_outcome: "Résultat du dernier appel",
      assigned_sales_id: "Représentant assigné (ID)",
      last_called_at: "Dernier appel",
      deal_stage: "Étape de l'affaire",
      last_email_at: "Dernier courriel",
      opened_campaign: "A ouvert la campagne",
      clicked_campaign: "A cliqué dans la campagne",
      tags: "Étiquette",
    },
    ops: {
      eq: "est",
      neq: "n'est pas",
      in: "parmi",
      nin: "hors de",
      gt: ">",
      gte: "≥",
      lt: "<",
      lte: "≤",
      exists: "renseigné",
      not_exists: "vide",
      days_since_gte: "depuis au moins (jours)",
      contains: "contient",
    },
    enums: {
      prospect_status: {
        new: "Nouveau",
        in_progress: "En cours",
        callback: "Rappel",
        demo_booked: "Démo réservée",
        in_pipeline: "En pipeline",
        not_interested: "Pas intéressé",
        bad_number: "Mauvais numéro",
        do_not_call: "Ne pas appeler",
        customer: "Client",
        cooling_down: "En pause",
      },
      last_call_outcome: {
        no_answer: "Pas de réponse",
        voicemail: "Boîte vocale",
        talked_callback: "Parlé, rappel",
        demo_booked: "Démo réservée",
        brochure_sent: "Brochure envoyée",
        not_interested: "Pas intéressé",
        wrong_number: "Mauvais numéro",
        do_not_call: "Ne pas appeler",
        unlogged: "Non consigné",
        skipped: "Ignoré",
      },
    },
    count:
      "%{total} compagnies, dont %{eligible} avec courriel valide et consentement",
    excluded: {
      no_email: "Sans courriel : %{n}",
      suppressed: "Désabonnés / supprimés : %{n}",
      do_not_call: "Ne pas appeler : %{n}",
      no_consent: "Sans consentement valide : %{n}",
    },
    fixed: {
      title: "Toujours exclus (non modifiable)",
      no_email: "Les compagnies sans adresse courriel",
      suppressed: "Les adresses désabonnées ou supprimées",
      do_not_call: "Les compagnies au statut « Ne pas appeler »",
      no_consent: "Les adresses sans consentement valide",
    },
    yes: "Oui",
    no: "Non",
    days: "jours",
  },
  en: {
    title: "Segments",
    new: "New segment",
    name: "Segment name",
    entity: "Type",
    updated: "Updated",
    entities: { companies: "Companies", contacts: "Contacts" },
    conditions: "Conditions",
    combine: "Combine",
    all: "All conditions",
    any: "At least one condition",
    add_condition: "Add a condition",
    add_group: "Add a group",
    remove: "Remove",
    remove_group: "Remove group",
    group_n: "Group %{n}",
    field_n: "Field %{n}",
    op_n: "Operator %{n}",
    value_n: "Value %{n}",
    choose: "Choose…",
    cap_reached: "Maximum of %{max} conditions reached.",
    invalid: "The segment filter is invalid.",
    err_days: "Enter a whole number of days between 0 and 36500.",
    err_id: "Enter a whole identifier between 1 and 2147483647.",
    err_list: "Maximum of 1000 items in the list.",
    entity_reset_confirm:
      "Changing the type clears the current conditions. Continue?",
    legacy_warning:
      "This segment uses an old filter format. Saving will replace it with the conditions below.",
    count_error: "Could not compute the lead count.",
    groups: {
      company: "Company",
      prospecting: "Prospecting",
      deals: "Deals",
      email: "Email",
      contacts: "Contacts",
    },
    fields: {
      trade: "Trade",
      region: "Region",
      city: "City",
      segment: "Segment",
      fit_score: "Fit score",
      high_quality: "High quality",
      has_email: "Has an email",
      created_at: "Created on",
      date_added: "Date added",
      prospect_status: "Prospect status",
      last_call_outcome: "Last call outcome",
      assigned_sales_id: "Assigned rep (ID)",
      last_called_at: "Last called",
      deal_stage: "Deal stage",
      last_email_at: "Last email",
      opened_campaign: "Opened the campaign",
      clicked_campaign: "Clicked in the campaign",
      tags: "Tag",
    },
    ops: {
      eq: "is",
      neq: "is not",
      in: "is one of",
      nin: "is none of",
      gt: ">",
      gte: "≥",
      lt: "<",
      lte: "≤",
      exists: "is set",
      not_exists: "is empty",
      days_since_gte: "at least (days) ago",
      contains: "contains",
    },
    enums: {
      prospect_status: {
        new: "New",
        in_progress: "In progress",
        callback: "Callback",
        demo_booked: "Demo booked",
        in_pipeline: "In pipeline",
        not_interested: "Not interested",
        bad_number: "Bad number",
        do_not_call: "Do not call",
        customer: "Customer",
        cooling_down: "Cooling down",
      },
      last_call_outcome: {
        no_answer: "No answer",
        voicemail: "Voicemail",
        talked_callback: "Talked, callback",
        demo_booked: "Demo booked",
        brochure_sent: "Brochure sent",
        not_interested: "Not interested",
        wrong_number: "Wrong number",
        do_not_call: "Do not call",
        unlogged: "Not logged",
        skipped: "Skipped",
      },
    },
    count: "%{total} leads, %{eligible} with a valid email and consent",
    excluded: {
      no_email: "No email: %{n}",
      suppressed: "Unsubscribed / suppressed: %{n}",
      do_not_call: "Do not call: %{n}",
      no_consent: "No valid consent: %{n}",
    },
    fixed: {
      title: "Always excluded (cannot be changed)",
      no_email: "Leads without an email address",
      suppressed: "Unsubscribed or suppressed addresses",
      do_not_call: "Leads with the status “Do not call”",
      no_consent: "Addresses without valid consent",
    },
    yes: "Yes",
    no: "No",
    days: "days",
  },
} as const;
